import axios from "axios";
import { base_url } from "../../utils/baseUrl";

// Create a package
const createPackage = async (packageData) => {
  const response = await axios.post(`${base_url}package`, packageData);
  return response.data;
};

// Get all packages
const getPackages = async () => {
  const response = await axios.get(`${base_url}package/getPackagesforadmin`);
  return response.data;
};

// Get a single package by ID
const getPackage = async (id) => {
  const response = await axios.get(`${base_url}package/getPackageByIdforadmin/${id}`);
  return response.data;
};

// Update package
const updatePackage = async (id, packageData) => {
  const response = await axios.put(`${base_url}package/${id}`, packageData);
  return response.data;
};

// Delete package
const deletePackage = async (id) => {
  const response = await axios.delete(`${base_url}package/deletePackage/${id}`);
  return response.data;
};

// Toggle package featured status
const togglePackageFeaturedStatus = async (id) => {
  const response = await axios.put(`${base_url}/toggle-package-status/${id}`);
  return response.data;
};

// Export all functions
const packageService = {
  createPackage,
  getPackages,
  getPackage,
  updatePackage,
  deletePackage,
  togglePackageFeaturedStatus,
};

export default packageService;
